export const ACTIONS = {
  SELECT: 'SELECT',
  DESELECT: 'DESELECT',
  DESELECT_ALL: 'DESELECT_ALL',
};

export const reducer = (state, action) => {
  const { type, data } = action;
  switch (type) {
    case ACTIONS.SELECT: {
      return {
        ...state,
        selected:
          state.selected.indexOf(data) === -1
            ? [...state.selected, data]
            : state.selected,
      };
    }

    case ACTIONS.DESELECT: {
      return {
        ...state,
        selected: state.selected.filter(item => item !== data),
      };
    }

    case ACTIONS.DESELECT_ALL: {
      return {
        ...state,
        selected: [],
      };
    }

    default:
      throw new Error();
  }
};
